import React, { useEffect, useState } from 'react'
import { Series, SeriesProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import utils from 'features/series/series-util'
import validations from 'features/series/series-validation'
import * as modelProps from 'models/series/series-property-definitions';

export interface SeriesProps {
    BuildList?: (page: any, name: SeriesProperties, form: Series) => JSX.Element[]
    page?: any
    title?: any
    form?: Series
    onUpdate?: (form: Series, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function SeriesForm(props: SeriesProps) {
    let [form, setForm] = useState({} as Series)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as Series)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as Series)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<Series, SeriesProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.SeriesProperties.Id,
                modelProps.SeriesProperties.Deleted,
                modelProps.SeriesProperties.Version,
                modelProps.SeriesProperties.Created,
                modelProps.SeriesProperties.Updated,
                modelProps.SeriesProperties.Owner,
                modelProps.SeriesProperties.MediaStatus,
                modelProps.SeriesProperties.Tags,
                modelProps.SeriesProperties.Genre,
            ].includes(x.name))
        },
        DropdownOptions: (page, propertyName, form) => {
            return utils.DropdownOptions(propertyName)
        },
        BuildList: (page, name: SeriesProperties, form: Series) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: Series,
            property: SeriesProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: SeriesProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>{BuildForm<Series, SeriesProperties>(args)}</React.Fragment>
    )
}
